import { render } from "./price-info.vue?vue&type=template&id=0b3cca56"
import script from "./price-info.vue?vue&type=script&lang=js"
export * from "./price-info.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__